












































import {
  computed,
  defineComponent,
  PropType,
  toRefs
} from '@nuxtjs/composition-api'
import { SantanderLoanInstallments } from '~/models/loan'
import { useI18n } from '~/compositions/i18n'
import { formatNumber } from '~/utils/number'
import { SantanderLoanInfo } from '~/constants/loan/loans'

enum AmountType {
  SUMMARY = 'summary',
  FEES = 'fees',
  DOWNPAYMENT = 'downpayment'
}

interface LoanAmount {
  type: AmountType
  count: number
  amount: number
}
export default defineComponent({
  model: {
    prop: 'show',
    event: 'input'
  },
  props: {
    show: {
      type: Boolean,
      required: true
    },
    installmentsInfo: {
      type: Object as PropType<SantanderLoanInstallments>,
      required: true
    },
    downpayment: {
      type: [Number, String],
      required: true
    },
    loanInfo: {
      type: Object as PropType<SantanderLoanInfo>,
      required: true
    }
  },
  setup(props, { emit }) {
    const { show, installmentsInfo, downpayment, loanInfo } = toRefs(props)

    const { t, tc } = useI18n()

    const visible = computed({
      get() {
        return show.value
      },
      set(value: boolean) {
        emit('input', value)
        emit('change', value)
      }
    })

    const amountsToShow = computed<LoanAmount[]>(() => {
      const amounts = [
        {
          type: AmountType.DOWNPAYMENT,
          count: 1,
          amount: Number(downpayment.value)
        },
        ...installmentsInfo.value.installmentSummary.map(s => {
          return {
            type: AmountType.SUMMARY,
            count: Number(s.installmentCount),
            amount: Number(s.installmentAmount)
          }
        })
      ]
      amounts.push({
        type: AmountType.FEES,
        count: 1,
        amount: Number(installmentsInfo.value.generalInfo.feesAmount)
      })
      return amounts
    })

    const getLabelForAmount = (amount: LoanAmount, index: number) => {
      if (amount.type === AmountType.FEES) {
        return t('loan_fees')
      } else if (amount.type === AmountType.DOWNPAYMENT) {
        return t('downpayment')
      }

      if (index === 1) {
        // 0 is downpayment
        return t('first_installment')
      } else if (
        index === amountsToShow.value.length - 2 &&
        loanInfo.value.type === 'balloon'
      ) {
        return t('last_big_installment')
      }
      return tc('next_installments', amount.count, { count: amount.count })
    }

    const totalAmount = computed(() =>
      formatNumber(
        amountsToShow.value.reduce((acc: number, amount: LoanAmount) => {
          return Number((acc + amount.amount * amount.count).toFixed(2))
        }, 0)
      )
    )

    return {
      visible,
      amountsToShow,
      getLabelForAmount,
      totalAmount,
      AmountType
    }
  }
})
